import { Injectable } from 'angular-ts-decorators';
import {
  DataFeedAws,
  ISkuObject,
} from '@shared/app/scripts/services/data-feed-aws';
import { Legacy } from './legacy';

/**
 * Service that retrieves raw skus from pos feed or sku feed
 * and returns properly formatted skus
 */
@Injectable('sku')
export class Sku {
  constructor(
    private $q: ng.IQService,
    private dataFeedAws: DataFeedAws,
    private legacy: Legacy,
  ) {
    'ngInject';
  }

  /**
   * and returns properly formatted skus
   * @param {string} barcode
   * Sku barcode
   * @return {Promise<ISkuObject>}
   * Returns the sku matrix ready to use in its context
   */
  get(barcode: string): ng.IPromise<ISkuObject> {
    let rawSku = this.dataFeedAws.findLogisticsSku(barcode),
      rawSkuPromise;

    if (rawSku === null && barcode.length === 13 && barcode[0] === '0') {
      rawSku = this.dataFeedAws.findLogisticsSku(barcode.substring(1));
    }

    if (rawSku === null) {
      rawSkuPromise = this.legacy.getSku(barcode);
      return rawSkuPromise.then((rawSku) => {
        return {
          articleCode: rawSku.articlecode,
          articleCodeSupplier: rawSku.articlecodesupplier,
          articleDescription: rawSku.articledescription,
          articleGroup: rawSku.articlegroup,
          barcode: rawSku.barcode,
          brand: rawSku.brand,
          buyPrice: rawSku.buyPrice,
          color: rawSku.color,
          colorCode: rawSku.colorcode,
          colorCodeSupplier: rawSku.colorCodeSupplier,
          colorDescription: rawSku.colorDescription,
          colorFamily: rawSku.colorFamily,
          colorSupplier: rawSku.colorSupplier,
          originalPrice: rawSku.originalPrice,
          price: rawSku.saleprice,
          qty: 0,
          size: rawSku.sizelabel,
          sizeIndex: parseInt(rawSku.sizeindex),
          subColorDescription: rawSku.subColorDescription,
          suggestedRetailPrice: rawSku.saleprice,
          valuePrice: rawSku.sellprice,
          vat: rawSku.vat,
        } as ISkuObject;
      });
    } else {
      rawSkuPromise = this.$q.when(rawSku);

      return this.$q.when({
        articleCode: rawSku.articleCode,
        articleCodeSupplier: rawSku.articleCodeSupplier,
        articleDescription: rawSku.articleDescription,
        articleGroup: rawSku.articleGroup,
        barcode: rawSku.barcode,
        brand: rawSku.brand,
        buyPrice: rawSku.buyPrice,
        color: `${rawSku.colorCode} ${rawSku.colorDescription}`,
        colorCode: rawSku.colorCode,
        colorCodeSupplier: rawSku.colorCodeSupplier,
        colorDescription: rawSku.colorDescription,
        colorFamily: rawSku.colorFamily,
        colorSupplier: rawSku.colorSupplier,
        originalPrice: rawSku.originalPrice,
        price: rawSku.price,
        qty: 0,
        size: rawSku.size,
        sizeIndex: rawSku.sizeIndex,
        subColorDescription: rawSku.subColorDescription,
        suggestedRetailPrice: rawSku.suggestedRetailPrice,
        valuePrice: rawSku.valuePrice,
        vat: rawSku.vat,
      } as ISkuObject);
    }
  }
}
